export { CarouselComponent } from './carousel.component';
export { CarouselModule } from './carousel.module';
export { SlideComponent } from './slide.component';
export { CarouselConfig } from './carousel.config';
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/ngx-bootstrap/carousel/index.js
// module id = 580
// module chunks = 5